/**************************************************
 * Nombre:       ListaOfertas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TarjetaOferta from "../../../Tarjetas/TarjetaOferta";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import Masonry from '@mui/lab/Masonry';
import Zoom from 'react-reveal/Zoom';


const ListaOfertas = ({items, cargaMas}) => {
    const {sCell, masSM} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 3}}
                spacing={6}
            >

                <Masonry columns={3} spacing={4}>
                    {items.map((e, i) => (
                        <Zoom >
                            <TarjetaOferta item={e}/>
                        </Zoom>
                    ))}
                </Masonry>
            </Grid>


        </Grid>
    )

}
export default ListaOfertas

